const plural = {
  reflexosNeuro: ' reflexos neurológicos não foram atingidos nos 15 primeiros dias de vida: ',
}

const singular = {
  reflexosNeuro: ' reflexo neurológico não foi atingido nos 15 primeiros dias de vida: ',
}

export const marcoMessages = (sizeList: number) => (sizeList > 1 ? plural : singular)
